// migrationHistorySlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { commonService } from "../../services/common.services";
import { apiConstants } from "../../constant/api.constant";

const initialState = {
    userData: [],
    loading: false,
    error: null,
};

export const getUserData = createAsyncThunk(
    "userData/getUserData",
    async (data, { rejectWithValue }) => {
        try {
            const response = await commonService.getWithToken(apiConstants.GET_USER_DATA, data);
            if (response && response.success && response.data) {
                return response.data; // return whole array, not [0]
            } else {
                return rejectWithValue("Failed to fetch User Data.");
            }
        } catch (error) {
            return rejectWithValue(error.message || "An error occurred.");
        }
    }
);

const UserDataSlice = createSlice({
    name: "userData",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getUserData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getUserData.fulfilled, (state, action) => {
                state.loading = false;
                state.userData = action.payload || [];
            })
            .addCase(getUserData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Failed to fetch data.";
            });
    },
});

export default UserDataSlice.reducer;
